import { useEffect } from "react";
import { toast } from "sonner";

const ALLOWED = "input, textarea, [contenteditable='true'], [data-allow-copy]";
const MSG = "© gkdeals.com — content is protected. Use the Share button to send this page.";

export default function CopyGuard() {
  useEffect(() => {
    let last = 0;
    const warn = () => {
      if (Date.now() - last > 3000) { toast.message(MSG, { id: "copy-guard" }); last = Date.now(); }
    };
    const block = (e) => {
      if (e.target instanceof Element && e.target.closest(ALLOWED)) return;
      e.preventDefault();
      if (e.type !== "selectstart") warn();
    };
    const events = ["contextmenu", "copy", "cut", "dragstart", "selectstart"];
    events.forEach((t) => document.addEventListener(t, block));
    document.body.classList.add("gk-protected");
    return () => {
      events.forEach((t) => document.removeEventListener(t, block));
      document.body.classList.remove("gk-protected");
    };
  }, []);
  return null;
}
